export default __webpack_public_path__ + "static/media/AXS.436141d4.png";